import { generateDefaultSelectors } from "@/redux/selectors.utils";

import { $AddressModuleName } from "./address.types";

const { isLoading } = generateDefaultSelectors($AddressModuleName);

export { isLoading };
